import React from 'react'
import PropTypes from 'prop-types'
import PreviewAvailability from '../PreviewAvailability'

const SchedulingListTitle = ({ title, showPreview, timezone }) => (
  <div
    className='d-flex align-items-center'
    style={{ minWidth: 'var(--booking-subtabs-width, auto)' }}>
    <h3 className='s3 mb-0'>{title}</h3>
    {showPreview && <PreviewAvailability timezone={timezone} />}
  </div>
)

SchedulingListTitle.propTypes = {
  title: PropTypes.string.isRequired,
  showPreview: PropTypes.bool,
  timezone: PropTypes.string,
}

export default SchedulingListTitle
